// Vista set-password — Sub-fase A.
// Aparece cuando el operario hace login por primera vez (must_set_password=true)
// o tras un reset-password del admin. Pide la nueva contraseña con confirmación.

import { ApiError } from '../api/client.js';
import { icon } from '../components/icons.js';
import { setPassword } from '../state/auth.js';
import { navigate } from '../router.js';

export function setPasswordView(_params, query) {
  return {
    mount(root) {
      // El username viene en query string ?u=...
      const username = query?.u || '';

      root.innerHTML = `
        <div class="app">
          <main class="content" style="padding:0;">
            <div class="login-wrap">
              <div class="brand">
                <div class="logo" aria-hidden="true">P</div>
                <h1>Establece tu contraseña</h1>
                <p class="tagline">Es tu primera vez — elige una contraseña personal.</p>
              </div>

              <form id="setpw-form" novalidate>
                <div class="field">
                  <label for="username">Usuario</label>
                  <input id="username" name="username" type="text"
                         autocapitalize="none" autocomplete="username"
                         value="${username.replace(/"/g, '&quot;')}" ${username ? 'readonly' : 'required'} />
                </div>
                <div class="field" style="margin-top:1rem;">
                  <label for="password">Contraseña nueva</label>
                  <input id="password" name="password" type="password"
                         autocomplete="new-password" required minlength="8" />
                  <p class="hint" style="color:var(--c-fg-muted);font-size:var(--fs-xs);margin-top:0.25rem;">
                    Mínimo 8 caracteres.
                  </p>
                </div>
                <div class="field" style="margin-top:0.75rem;">
                  <label for="password2">Repite la contraseña</label>
                  <input id="password2" name="password2" type="password"
                         autocomplete="new-password" required minlength="8" />
                </div>

                <div id="setpw-error" class="alert --error" hidden
                     style="margin-top:1rem;border-top:none;padding:0.6rem 0.85rem;">
                  <div class="ico">${icon('octagon-x', { size: 22 })}</div>
                  <div class="body"><strong id="setpw-error-msg"></strong></div>
                </div>

                <button class="btn --primary --block --lg" type="submit" id="setpw-submit"
                        style="margin-top:1rem;">Guardar y entrar</button>
              </form>
            </div>
          </main>
        </div>`;

      const form = root.querySelector('#setpw-form');
      const errBox = root.querySelector('#setpw-error');
      const errMsg = root.querySelector('#setpw-error-msg');
      const submit = root.querySelector('#setpw-submit');

      const showErr = (msg) => { errMsg.textContent = msg; errBox.hidden = false; };
      const hideErr = () => { errBox.hidden = true; };

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        hideErr();
        const fd = new FormData(form);
        const u = String(fd.get('username') || '').trim();
        const p1 = String(fd.get('password') || '');
        const p2 = String(fd.get('password2') || '');
        if (!u || !p1 || !p2) { showErr('Rellena los tres campos.'); return; }
        if (p1.length < 8) { showErr('La contraseña debe tener al menos 8 caracteres.'); return; }
        if (p1 !== p2) { showErr('Las dos contraseñas no coinciden.'); return; }

        submit.disabled = true;
        submit.textContent = 'Guardando…';
        try {
          await setPassword(u, p1);
          navigate('#/pedidos', { replace: true });
        } catch (e) {
          let msg = 'No se pudo establecer la contraseña.';
          if (e instanceof ApiError) {
            if (e.status === 404) msg = 'Usuario no encontrado. Pídele al admin que te dé de alta.';
            else if (e.status === 409) msg = 'Tu contraseña ya está establecida. Pídele al admin que la resetee.';
            else if (e.detail) msg = e.detail;
          }
          showErr(msg);
          submit.disabled = false;
          submit.textContent = 'Guardar y entrar';
        }
      });

      setTimeout(() => root.querySelector('#password')?.focus(), 50);
    },
    unmount() { /* nada */ },
  };
}
